/**
 * Patients/Residents API Module
 * CCH Care — Phase 2
 */
import client from './client';

export async function getAssignedResidents(shiftAssignmentId, careShiftId) {
  const response = await client.get('/residents/assigned.php', {
    params: { shift_assignment_id: shiftAssignmentId, care_shift_id: careShiftId }
  });
  return response.data;
}

export async function getResidentDetail(patientId, careShiftId) {
  const response = await client.get('/residents/detail.php', {
    params: { patient_id: patientId, care_shift_id: careShiftId }
  });
  return response.data;
}
